import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
  TemplateRef,
  inject,
  viewChild,
} from '@angular/core';
import { getRandomId } from '../../../../utils/get-random-id';
import { TabsUIComponent } from '../tabs.component';

@Component({
  selector: 'fr8bot-ui-tab',
  imports: [],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabUIComponent {
  private tabsContainer = inject(TabsUIComponent);

  label = input<string | null>(null);
  testId = input<string | null>(null);
  readonly template = viewChild.required<TemplateRef<HTMLElement>>('template');
  public readonly tabId = signal(`tab-${getRandomId()}`).asReadonly();
  public readonly isTabActive = computed(() => {
    const activeTabId = this.tabsContainer.activeTabId();
    return this.tabId() === activeTabId;
  });
}
